var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"d-flex align-center justify-center elevation-0 report-card-notready"},[_c('p',[_c('v-icon',[_vm._v("mdi-autorenew mdi-spin")]),_vm._v(" The data for this chart is "),(_vm.modelCount <
    _vm.apiCount || _vm.resource === '')?_c('span',[_vm._v("importing")]):_c('span',[_vm._v("generating")]),_vm._v(". "),_c('br')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }